module.exports = __webpack_public_path__ + "static/media/tag_white.a8fafa68.svg";